import { z } from '@harvestiq/zod';
import { zIsoDate } from '@harvestiq/zod';

export const salesEffectiveDatesRequestSchema = z.object({
  limit: z.number().optional(),
});

export type SalesEffectiveDatesRequest = z.infer<
  typeof salesEffectiveDatesRequestSchema
>;

export const salesEffectiveDatesResponseSchema = z.object({
  data: zIsoDate().array(),
});

export type SalesEffectiveDatesResponse = z.infer<
  typeof salesEffectiveDatesResponseSchema
>;

export const getLrpSalesEffectiveDatesParamsSchema = z.object({
  limit: z.coerce.number().optional(),
});

export const getLrpSalesEffectiveDatesResponseSchema = z
  .object({
    salesEffectiveDates: zIsoDate().array(),
  })
  .openapi({
    example: {
      salesEffectiveDates: ['2024-12-30', '2024-12-29', '2024-12-28'],
    },
  });

export type GetLrpSalesEffectiveDatesResponse = z.infer<
  typeof getLrpSalesEffectiveDatesResponseSchema
>;
